<template>
  <div :class="$style.base">
    <div :class="$style.poweredBy">
      {{ $t('completed.powered_by') }}
    </div>
    <div :class="$style.logo" @click="onLogoClick" v-test="'salonized-logo'">
      <Logo />
    </div>
  </div>
</template>

<script setup lang="ts">
import Logo from '@/components/Logo.vue';
import widgetSettings from '@/widget-settings';

const onLogoClick = () => {
  window.parent.postMessage('szOpenSalonizedWebsite', '*');
};
</script>

<style lang="scss" module>
.base {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: rgba(0, 0, 0, 0.5);
  padding: $spacing;
}

.logo {
  cursor: pointer;
}

.poweredBy {
  font-size: 12px;
  margin-bottom: 6px;
}
</style>
